import React from 'react';
import { Typography, Box, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MetricContainer = styled(Box)({
  padding: '28px',
  borderRadius: '12px',
  backgroundColor: '#1a2035',
});

export const TotalBalance = styled(Typography)({
  '&.MuiTypography-root': {
    color: '#10b981 !important', // Primary green
    fontSize: '3.5rem',
    fontWeight: 'bold',
    marginBottom: '4px',
    letterSpacing: '-0.02em'
  }
});

export const MetricLabel = styled(Typography)({
  '&.MuiTypography-root': {
    color: '#6ee7b7 !important', // Light green
    fontSize: '0.875rem',
    letterSpacing: '0.025em',
    textTransform: 'uppercase',
    opacity: 0.9
  }
});

export const MetricGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '32px',
  margin: '32px 0'
});

export const MetricValue = styled(Typography)({
  '&.MuiTypography-root': {
    color: '#34d399 !important', // Medium green
    fontSize: '2.5rem',
    fontWeight: 'bold',
    marginBottom: '8px',
    letterSpacing: '-0.01em'
  }
});

export const ActivityContainer = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '24px',
  margin: '24px 0'
});

export const ActivityMetric = styled(Box)({
  padding: '20px',
  borderRadius: '8px',
  backgroundColor: '#1e293b',
  transition: 'transform 0.2s ease',
  '&:hover': {
    transform: 'translateY(-2px)'
  }
});

interface FundBalancesProps {
  totalAssets?: number;
  activeFunds?: number;
  averageBalance?: number;
  monthlyActivity?: {
    deposits: number;
    withdrawals: number;
  };
}

export const FundBalances: React.FC<FundBalancesProps> = ({
  totalAssets = 0,
  activeFunds = 0,
  averageBalance = 0,
  monthlyActivity = { deposits: 0, withdrawals: 0 }
}) => {
  return (
    <MetricContainer>
      {/* Total AUM */}
      <Box mb={4}>
        <TotalBalance>${(totalAssets || 0).toLocaleString()}</TotalBalance>
        <MetricLabel>Total Assets Under Management</MetricLabel>
      </Box>

      {/* Key Metrics */}
      <MetricGrid>
        <Box>
          <MetricValue>{activeFunds}</MetricValue>
          <MetricLabel>Active Funds</MetricLabel>
        </Box>
        <Box>
          <MetricValue>${(averageBalance || 0).toLocaleString()}</MetricValue>
          <MetricLabel>Average Fund Balance</MetricLabel>
        </Box>
      </MetricGrid>

      {/* Monthly Activity */}
      <Box mt={4}>
        <MetricLabel sx={{ mb: 2 }}>Monthly Activity</MetricLabel>
        <ActivityContainer>
          <ActivityMetric>
            <MetricValue sx={{ color: '#10b981 !important', fontSize: '2rem' }}>
              +${(monthlyActivity.deposits || 0).toLocaleString()}
            </MetricValue>
            <MetricLabel>Deposits</MetricLabel>
          </ActivityMetric>
          <ActivityMetric>
            <MetricValue sx={{ color: '#ef4444 !important', fontSize: '2rem' }}>
              -${(monthlyActivity.withdrawals || 0).toLocaleString()}
            </MetricValue>
            <MetricLabel>Withdrawals</MetricLabel>
          </ActivityMetric>
        </ActivityContainer>
      </Box>
    </MetricContainer>
  );
}; 